import { render, staticRenderFns } from "./RelateIcon.vue?vue&type=template&id=cf631ffa&"
import script from "./RelateIcon.vue?vue&type=script&lang=js&"
export * from "./RelateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports